import { useAuth } from '../context/AuthContext';

export const usePermission = () => {
  const { user, can, hasRole } = useAuth();
  
  return {
    can,
    hasRole,
    user,
    // Pre-defined helpers for common checks
    canViewProjects: () => can('projects.view'),
    canManageProjects: () => can('projects.manage'),
    
    canViewTeam: () => can('team_performance.view'),
    canManageTeam: () => can('team_performance.manage'),

    canViewInvoices: () => can('invoices.view'),
    canManageInvoices: () => can('invoices.manage'),
    
    canViewAnalytics: () => can('analytics.view'),
    
    isSuperAdmin: () => hasRole('Super Admin')
  };
};

export default usePermission;
